import React, {useCallback, useState} from 'react';
import {Button, Col, Row} from 'reactstrap';

import Modal from 'components/Modal';
import useExitIntent from 'utils/useExitIntent.js';

export default function ModalExitLanding(props) {
  const {isOpen, toggle} = useExitIntent(30000);
  return (
    <Modal className="modal-exit-intent modal-exit-intent-landing" isOpen={isOpen} toggle={toggle}>
      <Row className="text-center text-lg-left d-flex align-items-stretch m-0">
        <Col xs="12" lg="7" className="modal-exit-intent-copy order-lg-2 my-auto">
          <h4 className="section-heading mb-4">Before you press X…</h4>
          <p>Will your next meal have the diabetes-busting nutrients you need to protect yourself?</p>
          <p>
            <b>Join the Tackling Type 2 Masterclass</b>
          </p>
          <Row className="d-flex align-items-center mt-5">
            <Col xs="12" lg="6" className="mb-4 mb-lg-0 pr-lg-0">
              <Button className="text-uppercase text-white btn-exit-orange" color="cta" onClick={toggle} block>
                Yes, I want to protect my health
              </Button>
            </Col>
            <Col xs="12" lg="6">
              <Button className="text-uppercase text-800 text-white" color="exit-gray" onClick={toggle} block>
                No thanks, I’ll take my chances
              </Button>
            </Col>
          </Row>
        </Col>
        <Col xs="12" lg="5" className="exit-modal-image-col order-lg-1">
          <div
            className="exit-modal-image"
            style={{backgroundImage: `url('${require('static/backgrounds/1216786444-exit.jpg')}')`}}
          />
        </Col>
      </Row>
    </Modal>
  );
}
